import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import { FORM_CARTAS_DE_PORTE_VETADAS } from '../../../config/forms'
import { INTERVALO_CORTO } from '../../../config/settings'

class DetalleCartasDePorteVetadasDialog extends Component {
  parseData (data) {
    const parsedData = []
    data.data.forEach(entry => {
      parsedData.push({ ...entry, detalle: entry })
    })
    return parsedData
  }

  async componentDidMount () {
    const { detalleCartaDePorteVetada } = this.props
    this.props.updateTablaDeCartasDePorteVetadasDetalle({
      columns: this.COLUMNS,
      data: detalleCartaDePorteVetada,
      title: `Detalle de Carta de Porte`,
      isLoading: false,
      extraOptions: { print: false, pagination: false }
    })
  }

  render () {
    const { detalle } = this.props
    return (
      <div className='dialog-container'>
        <h4>Detalle de Carta de Porte Electrónica # <b>{detalle.numero}</b></h4>
        <h5>Error: <b>{detalle.error}</b></h5>
        <hr />
        <h6>Fecha de Cupo: <b>{detalle.fechaCupo}</b> Tipo de Cupo: <b>{detalle.tipoCupo}</b></h6>
        <h6>Fecha de Partida: <b>{detalle.fechaDePartida}</b></h6>
        <h6>Fecha de Vencimiento: <b>{detalle.fechaDeVencimiento}</b></h6>
        <h6>Codigo de Cupo: <b>{detalle.codigoCupo}</b></h6>
        <h6>Exportador: <b>{detalle.exportador}</b></h6>
        <h6>Titular CPE: <b>{detalle.titularCp}</b></h6>
        <h6>Remitente Comercial Productor: <b>{detalle.remitenteComercialProductor}</b></h6>
        <h6>Remitente Comercial Venta Primaria: <b>{detalle.remitenteComercialVentaPrimaria}</b></h6>
        <h6>Remitente Comercial Venta Secundaria: <b>{detalle.remitenteComercialVentaSecundaria}</b></h6>
        <h6>Remitente Comercial Venta Secundaria 2: <b>{detalle.remitenteComercialVentaSecundaria2}</b></h6>
        <h6>Corredor Venta Primaria: <b>{detalle.corredorVentaPrimaria}</b></h6>
        <h6>Corredor Venta Secundaria: <b>{detalle.corredorVentaSecundaria}</b></h6>
        <h6>Entregador: <b>{detalle.entregador}</b></h6>
        <h6>Transportista: <b>{detalle.transportista}</b></h6>
        <h6>Chofer: <b>{detalle.chofer}</b></h6>
        <h6>Camión: <b>{detalle.camion}</b></h6>
        <h6>Peso Bruto: <b>{detalle.pesoBruto}</b> / Peso Tara: <b>{detalle.pesoTara}</b> / Peso Neto: <b>{detalle.pesoNeto}</b></h6>
        <h6>Cosecha: <b>{detalle.cosecha}</b></h6>
        <hr />
        <h6>Razón Social Exportador Nominado: <b>{detalle.razonSocialExportadorNominado}</b></h6>
        <h6>Cuit Exportador Nominado: <b>{detalle.exportadorNominado}</b></h6>
        <h6>Razón Social Titular de Cupo Nominado: <b>{detalle.razonSocialTitularDeCupoNominado}</b></h6>
        <h6>Cuit Titular de Cupo Nominado: <b>{detalle.titularDeCupoNominado}</b></h6>
        <h6>Razón Social Corredor Nominado: <b>{detalle.razonSocialCorredorNominado}</b></h6>
        <h6>Cuit Corredor Nominado: <b>{detalle.corredorNominado}</b></h6>
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    detalleCartaDePorteVetada: state.cartaDePorte.detalleCartaDePorteVetada,
    detalle: state.cartaDePorte.detalle
  }
}

export default connect(mapStateToProps, actions)(reduxForm({
  form: FORM_CARTAS_DE_PORTE_VETADAS,
  enableReinitialize: true
})(DetalleCartasDePorteVetadasDialog))
